import React,{useState,useEffect} from 'react';
import { Form, Button } from "react-bootstrap";
import { assignToken } from "../../service/auth";
import Alert from "react-bootstrap/Alert";
import { Link, Route, Routes } from "react-router-dom";
import ManageSubscription from '../../Frontend/ManageSubscription';

export default function Assignpackage() {
    
    const [validated, setValidated] = useState(false);
    const [token, setToken] = useState("");
    const [showAlert, setAlert] = useState(false);
    const [showAlertMsg, setAlertMsg] = useState({ type: "", msg: "" });

    function AlertShow(props) {
        if (showAlert) {
            return (
            <Alert variant={props.type}>
                <Alert.Heading>Alert !</Alert.Heading>
                <p>{props.text}</p>
            </Alert>
            );
        }
    }

    let loader;
    const submitData = async (event) => {
        setAlertMsg({ type: "", msg: "" });
        setAlert(false);
        event.preventDefault();
        if(!token){
            setValidated(false);
            setAlertMsg({ type: "danger", msg: "Please enter a valid token" });
            setAlert(true);
        }else{
        setValidated(true)
        const user_email = localStorage.getItem("email");
        let result = await assignToken(user_email, token)
        //alert(JSON.stringify(result))
        if(!result.data.error && !result.data.errorUser) {
            setAlertMsg({ type: "success", msg: "You have been assigned to "+token });
            setAlert(true);
        }

        else if(result.data.error){
            setAlertMsg({ type: "danger", msg: result.data.error.response});
            setAlert(true);
        }
        // else if(!result.data.errorUser) {
        //     setAlertMsg({ type: "danger", msg: "User limit for this package has already been exceeded. Please upgrade your package more suited to your needs"});
        //     setAlert(true);
        // }
        else {
            setAlertMsg({ type: "danger", msg: "Some error occurred"});
            setAlert(true);
        }
        console.log(result.data.error);
    }
            
    }

    return (
        <div>
          <ManageSubscription/>
            <div className='dashbord-page'>
                <div className='container assign-yourself'>
                    <div className='Quickly-login'>
                    <h1>Assign Yourself</h1>
                    <AlertShow type={showAlertMsg.type} text={showAlertMsg.msg} />
                    <Form noValidate validated={validated} onSubmit={submitData}  className="row token-form" >
                        <label className="">Enter Package Token</label>
                        <Form.Group className="mb-4 col-md-12" controlId="formBasicName">
                            <Form.Control
                                name="token" 
                                label='Enter Token'
                                placeholder='Enter Token'
                                value={token}
                                onChange={(e) => setToken(e.target.value)}
                            />
                        </Form.Group>
                        <div className="sign-up-button">
                        {loader}
                            <Button type="submit" variant="primary" >
                                Submit
                            </Button>
                        </div>
                    </Form>
                    </div>
                </div>
            </div>    
        </div>
    );
}